import { render, staticRenderFns } from "./ViHeader.vue?vue&type=template&id=83a250c6&scoped=true"
import script from "./ViHeader.vue?vue&type=script&lang=js"
export * from "./ViHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a250c6",
  null
  
)

export default component.exports